import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=78b3b6a5&scoped=true&"
import script from "./AppDetail.vue?vue&type=script&lang=ts&"
export * from "./AppDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=78b3b6a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b3b6a5",
  null
  
)

export default component.exports